module.exports = __webpack_public_path__ + "img/logotip-UM.7962fa0b.png";